import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import AttendanceServices from "../../../services/AttendanceServices";
import AssetVehicleServices from "../../../services/AssestVechileServices";
import LocationServices from "../../../services/LocationServices";
import FilePreviewModal from "../Accounts/FilePreviewModal";
import * as XLSX from "xlsx";
import Swal from "sweetalert2"; // Import SweetAlert2

const MachineLogSheet = () => {

    const [vehicles, setVehicles] = useState([]); // State for storing vehicles
    const [selectedVehicle, setSelectedVehicle] = useState("all"); // State for dropdown value
    const [expandedRow, setExpandedRow] = useState(null);
    const [open, setOpen] = useState(true);
    const [open2, setOpen2] = useState(true);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState("all");
    const [totalcount, setTotalCount] = useState(0)
    const user = JSON.parse(localStorage.getItem("userDetails"));
    const [showPreview, setShowPreview] = useState(false);
    const [previewFile, setPreviewFile] = useState(null);
    const availableStores = user?.data?.user?.store || [];
    const defaultStore = availableStores[0]?._id || "";
    const [stores, setStores] = useState(availableStores);
    const [selectedStore, setSelectedStore] = useState(defaultStore);
    const role =
        user?.data?.user?.role;

    const canViewAllStores =
        role === "superAdmin" ||
        role === "director";

    useEffect(() => {

        AssetVehicleServices.getAllAssetVehicles()
            .then(response => {

                if (response?.data) {

                    setVehicles(response?.data);

                }

            })
            .catch(error => {

                console.error(
                    "Error fetching asset vehicles:",
                    error
                );

            });

    }, []);

    useEffect(() => {

        if (canViewAllStores) {

            LocationServices.getStore()
                .then((response) => {

                    const allStores =
                        response?.data?.data || [];

                    setStores(allStores);

                    if (allStores.length > 0) {

                        setSelectedStore(
                            allStores[0]?._id || ""
                        );

                    }

                })
                .catch((error) => {

                    console.error(
                        "Error fetching stores:",
                        error
                    );

                });

        } else {

            setStores(availableStores);

            setSelectedStore(
                availableStores[0]?._id || ""
            );

        }

    }, [canViewAllStores]);

    const handleStoreChange = (e) => {
        setSelectedStore(e.target.value);
    };


    const fetchReport = async () => {
        if (!fromDate || !toDate) {
            Swal.fire({
                icon: "warning",
                title: "Missing Dates",
                text: "Please select both From and To dates.",
            });
            return;
        }

        setLoading(true);
        try {
            const response = await AttendanceServices.pdfReport({
                fromDate: fromDate,
                toDate: toDate,
                vehicle: selectedVehicle,
                store: selectedStore, // 👈 add this line
            });

            setReportData(response.data);
            setTotalCount(response.count);

            Swal.fire({
                icon: "success",
                title: "Report Generated",
                text: `Report Successfully Generated for the Selected Date Range.`,
            });
        } catch (error) {
            console.error("Error fetching report data:", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to fetch report data. Please try again later.",
            });
        } finally {
            setLoading(false);
        }
    };

    const downloadReportAsHtml = () => {
        if (reportData.length === 0) {
            Swal.fire({
                icon: "info",
                title: "No Data",
                text: "No data available to download.",
            });
            return;
        }

        const from = new Date(fromDate);
        const to = new Date(toDate);

        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        const fromMonth = monthNames[from.getMonth()] + " " + from.getFullYear();
        const toMonth = monthNames[to.getMonth()] + " " + to.getFullYear();

        const reportMonth = fromMonth === toMonth ? fromMonth : `${fromMonth} - ${toMonth}`;

        const startMeter = reportData[0]?.startKM || "N/A";

        let endMeter = "N/A";
        for (let i = reportData.length - 1; i >= 0; i--) {
            if (reportData[i]?.endTime && reportData[i]?.endKM != null) {
                endMeter = reportData[i].endKM;
                break;
            }
        }

        let totalHMR = 0;
        reportData.forEach(item => {
            if (item.startKM != null && item.endKM != null) {
                totalHMR += item.endKM - item.startKM;
            }
        });
        totalHMR = totalHMR.toFixed(2);

        let totalShiftHours = 0;
        reportData.forEach(item => {
            if (item.startTime && item.endTime) {
                const start = new Date(item.startTime);
                const end = new Date(item.endTime);
                const diffHours = (end - start) / (1000 * 60 * 60);
                if (!isNaN(diffHours) && diffHours > 0) {
                    totalShiftHours += diffHours;
                }
            }
        });
        totalShiftHours = totalShiftHours.toFixed(2);

        // ✅ Calculate Total Diesel Quantity
        let totalDieselQty = 0;
        reportData.forEach(item => {
            if (Array.isArray(item?.desile)) {
                totalDieselQty += item.desile.reduce((sum, d) => sum + (d.desileQty || 0), 0);
            }
        });
        totalDieselQty = totalDieselQty.toFixed(2);

        const storeName = reportData[0]?.store?.name || "________";
        const firstVehicle = reportData.find(
            item => item?.vehicle?.asset?.masterItem?.description
        );

        const vehicleName = firstVehicle
            ? `${firstVehicle?.vehicle?.asset?.masterItem?.description} / ${firstVehicle?.vehicle?.asset?.equipmentNo || ""}`
            : "________";

        const tableRows = reportData.map((item, index) => {
            const dieselQty = (item?.desile?.reduce((sum, d) => sum + d.desileQty, 0) || 0).toFixed(2);
            return `
        <tr>
            <td>${index + 1}</td>
            <td>${item?.startTime?.split("T")[0] || ""}</td>
            <td>${item?.store?.name || ""}</td>
            <td>${item?.vehicle?.asset?.masterItem?.description || "-"} /${item?.vehicle?.asset?.equipmentNo || "-"}</td>
            <td>${item?.driver?.name || ""}</td>
            <td>${formatDate(item?.startTime)}</td>
            <td>${item?.startKM || ""}</td>
            <td>${formatDate(item?.endTime)}</td>
            <td>${item?.endKM || 0}</td>
            <td>${handleHMR(item?.startKM, item?.endKM).toFixed(2)}</td>
            <td>${dieselQty}</td>
            <td>${item?.status || ""}</td>
        </tr>`;
        }).join("");

        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
       <!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Machine Log Sheet</title>
  <style>
    body {
      font-family: Calibri, sans-serif;
      margin: 20px;
    }
    .outer-table {
      width: 100%;
      border: 1px solid #000;
      border-collapse: collapse;
    }
    .outer-table td {
      border: 1px solid #000;
      padding: 10px;
      vertical-align: top;
    }
    h2 {
      text-align: center;
      font-size: 20px;
      margin: 0;
      padding: 10px 0;
    }
    .info-box {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      font-size: 12px;
    }
    .info-item {
      width: 48%;
    }
    .info-item b {
      width: 160px;
      display: inline-block;
    }
    table.inner-table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 10px;
    }
    .inner-table th, .inner-table td {
      border: 1px solid #000;
      padding: 6px;
      font-size: 12px;
      text-align: left;
    }
    .inner-table th {
      background-color: #f0f0f0;
    }
    .summary-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 4px;
      font-size: 12px;
      margin-top: 10px;
    }
    .footer-notes {
      font-size: 11px;
      margin-top: 10px;
    }
    .signatures {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      font-size: 12px;
    }
    .signature-box {
      width: 24%;
      text-align: center;
    }
    .print-btn {
      margin-bottom: 20px;
    }
    @media print {
      .print-btn {
        display: none;
      }
    }
  </style>
</head>
<body>

  <button class="print-btn" onclick="window.print()">Print PDF</button>

  <table class="outer-table">
    <tr>
      <td colspan="2">
        <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 0;">
          <div style="font-size: 20px; font-weight: bold;">INDIGO INFRAPROJECTS PVT. LTD.</div>
          <img src="https://indigoinfra.in/img/product/product-1739471679615.jpeg" alt="Indigo Logo" width="100" height="50"/>
        </div>
      </td>
    </tr>

    <tr>
      <td colspan="2">
        <div class="info-box">
         <div class="info-item"><b>SITE/PROJECT:</b> ${storeName}</div>
          <div class="info-item"><b>S.NO.:</b> _____________</div>
          <div class="info-item"><b>RA BILL NO:</b> ____________________</div>
          <div class="info-item"><b>MONTH:</b> ${reportMonth}</div>
          <div class="info-item"><b>SUB CONTRACTOR:</b> ____________________</div>
          <div class="info-item"><b>WORK ORDER:</b> ____________________</div>
          <div class="info-item"><b>TERMS:</b> 12 hrs./24 hrs./30 days</div>
          <div class="info-item"><b>VENDOR CODE:</b> ____________________</div>
          <div class="info-item"><b>BILL PERIOD:</b> from: ${fromDate} to: ${toDate}</div>
          <div class="info-item"><b>EQUIPMENT NAME:</b> ${vehicleName}</div>
        </div>
      </td>
    </tr>

    <tr>
      <td colspan="2">
       <table class="inner-table">
        <thead>
            <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>Store</th>
                <th>Machine Name</th>
                <th>Driver Name</th>
                <th>Start Time</th>
                <th>Start HMR</th>
                <th>End Time</th>
                <th>End HMR</th>
                <th>Day HMR</th>
                <th>Diesel Qty</th>
                <th>Status</th>
            </tr>
        </thead>
        <tbody>
            ${tableRows}
        </tbody>
        </table>
      </td>
    </tr>

    <tr>
      <td colspan="2">
        <div class="summary-grid">
          <div><b>Start Meter:</b>  ${startMeter}</div>
          <div><b>End Meter:</b>  ${endMeter}</div>
          <div><b>Total HMR:</b>  ${totalHMR}</div>
          <div><b>Avg.:</b> ________</div>
          <div><b>Shift Hours:</b>  ${totalShiftHours} Hrs</div>
          <div><b>Total Diesel Consumed:</b>  ${totalDieselQty} Ltr</div>
          <div><b>B/D Hours:</b> ________</div>
          <div><b>Normal Payable Hrs/Day:</b> ________</div>
          <div><b>OT Hours:</b> ________</div>
          <div><b>Normal Hours at Rs. _____ /Hr:</b> ________</div>
          <div><b>OT Hours at Rs. _____ /Hr:</b> ________</div>
          <div><b>Total Amount Payable:</b> ________</div>
        </div>
      </td>
    </tr>

    <tr>
      <td colspan="2">
        <div class="signatures">
          <div class="signature-box"><strong>Prepared By<br/>(Site)</strong></div>
          <div class="signature-box"><strong>Checked By<br/>(Site I/C)</strong></div>
          <div class="signature-box"><strong>Store Coordinator</strong></div>
          <div class="signature-box"><strong>Approved By</strong></div>
        </div>
      </td>
    </tr>
  </table>

</body>
</html>
    `);

        printWindow.document.close();
        printWindow.focus();
    };




    //date format

    const formatDate = (isoString) => {
        if (!isoString) return "N/A"; // Handle undefined/null values

        const date = new Date(isoString);
        if (isNaN(date.getTime())) return "N/A"; // Handle invalid date values

        // Extract date parts using `toLocaleString`
        const day = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", day: "2-digit" });
        const month = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", month: "2-digit" });
        const year = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", year: "numeric" });
        const hours = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", hour: "2-digit", hour12: false });
        const minutes = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", minute: "2-digit" });
        const seconds = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", second: "2-digit" });

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    };

    let HMR = 0;

    function handleHMR(start, end) {
        if (!end) {
            return 0; // Return 0 if `end` is undefined or falsy
        }

        let difference = end - start; // Calculate difference
        HMR += difference; // Update HMR

        return difference; // Return the calculated difference
    }


    const toggleRow = (index) => {
        setExpandedRow((prev) => (prev === index ? null : index));
    };

    const getImageUrl = (fileName) => {

        if (!fileName) return "";

        const baseUrl =
            window.location.hostname === "localhost"
                ? "http://localhost:3001"
                : "https://indigoinfra.in";

        return `${baseUrl}/img/attendance/${fileName}`;
    };


    return (
        <>
            <FilePreviewModal
                show={showPreview}
                handleClose={() => setShowPreview(false)}
                file={previewFile}
            />
            <div className="col-xl-12">
                <div className="filter cm-content-box box-primary">
                    <div className={`content-title`}>
                        <div className="cpa">
                            <i className="fas fa-filter me-2"></i>Filter
                        </div>
                        <div className="tools">
                            <Link
                                to={"#"}
                                className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                                onClick={() => setOpen(!open)}
                            >
                                <i className="fas fa-angle-up"></i>
                            </Link>
                        </div>
                    </div>
                    <Collapse in={open}>
                        <div className="cm-content-body form excerpt">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-2 col-xxl-2">
                                        <label className="ms-2">From</label>
                                        <input
                                            type="date"
                                            name="fromDate"
                                            className="form-control mb-xxl-0 mb-3"
                                            value={fromDate}
                                            onChange={(e) => setFromDate(e.target.value)}
                                        />
                                    </div>

                                    <div className="col-xl-2 col-xxl-2">
                                        <label className="ms-2">To</label>
                                        <input
                                            type="date"
                                            name="toDate"
                                            className="form-control mb-xxl-0 mb-3"
                                            value={toDate}
                                            onChange={(e) => setToDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-xl-2 col-xxl-2">

                                        <label className="ms-2">Machine</label>
                                        <select
                                            className="form-select"
                                            value={selectedVehicle}
                                            style={{ height: "55px" }}
                                            onChange={(e) => setSelectedVehicle(e.target.value)}
                                        >
                                            <option value="all">
                                                All Machines
                                            </option>

                                            {vehicles.map((vehicle) => (
                                                <option
                                                    key={vehicle._id}
                                                    value={vehicle._id}
                                                >
                                                    {vehicle?.asset?.masterItem?.description || "-"}|
                                                    {vehicle?.asset?.equipmentNo || "-"} |
                                                    {vehicle?.asset?.vendor || "-"}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-xl-3 col-xxl-3">
                                        <label>Select Store</label>
                                        <select
                                            style={{ height: "55px" }}
                                            className="form-select mb-xl-0 mb-3"
                                            value={selectedStore}
                                            onChange={handleStoreChange}
                                        >
                                            {stores.map((store) => (
                                                <option key={store._id} value={store._id}>
                                                    {store.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-xl-3 col-xxl-3">
                                        <label className="ms-2">Search</label>
                                        <button
                                            className="form-control btn btn-primary"
                                            onClick={fetchReport}
                                            disabled={loading}
                                        >
                                            {loading ? "Loading..." : "Generate Report"}
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>

                <div className="filter cm-content-box box-primary">
                    <div className={`content-title`}>
                        <div className="cpa">
                            <i className="fa fa-list me-2" aria-hidden="true"></i>Machine Log<span className="badge bg-orange ms-2">{totalcount}</span>
                        </div>
                        <div className="tools">
                            <Link
                                to={"#"}
                                className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                onClick={() => setOpen2(!open2)}
                            >
                                <i className="fas fa-angle-up"></i>
                            </Link>
                        </div>
                    </div>
                    <Collapse in={open2}>
                        <div className="cm-content-body form excerpt">
                            <div className="card-body">
                                <div className="mb-3 text-end">
                                    {!loading && reportData?.length > 0 && (
                                        <p onClick={downloadReportAsHtml} className="text-end btn btn-rounded btn-md btn-primary me-3">
                                            <i className="las la-download scale5 me-3"></i> Download Report
                                        </p>
                                    )}
                                </div>
                                <div className="table-responsive">

                                    <table className="table table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Date</th>
                                                <th>Store</th>
                                                <th>Machine Name</th>
                                                <th>Driver Name</th>
                                                <th>Start Time</th>
                                                <th>Start HMR</th>
                                                <th>End Time</th>
                                                <th>End HMR</th>
                                                <th>Day HMR</th>
                                                <th>Diesel Qty</th>
                                                <th>Diesel Details</th>
                                                <th>Current Status</th>
                                                <th>Updated Date</th>
                                                <th>Start Reading Image</th>
                                                <th>End Reading Image</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reportData.length > 0 ? (
                                                <>
                                                    {reportData.map((item, index) => {
                                                        const totalDieselQty = item?.desile?.reduce((sum, diesel) => sum + diesel.desileQty, 0) || 0;
                                                        return (
                                                            <>
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item?.startTime.split("T")[0]}</td>
                                                                    <td className="scrollable-description">{item?.store?.name}</td>
                                                                    <td>
                                                                        {item?.vehicle?.asset?.masterItem?.description || "-"} /
                                                                        {item?.vehicle?.asset?.equipmentNo || "-"}
                                                                    </td>
                                                                    <td>{item?.driver?.name}</td>
                                                                    <td>{formatDate(item?.startTime)}</td>
                                                                    <td>{item?.startKM}</td>
                                                                    <td>{formatDate(item?.endTime)}</td>
                                                                    <td>{item?.endKM}</td>
                                                                    <td>{handleHMR(item?.startKM, item?.endKM).toFixed(2)}</td>
                                                                    <td>{totalDieselQty.toFixed(2)}</td>
                                                                    <td>
                                                                        {item?.desile?.length > 0 && (
                                                                            <button
                                                                                className="btn btn-success btn-sm"
                                                                                onClick={() => toggleRow(index)}
                                                                            >
                                                                                {expandedRow === index ? "Hide Details" : "Show Details"}
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                    <td>{item?.status}</td>
                                                                    <td>{item?.updatedAt.split("T")[0]}</td>
                                                                    <td className="scrollable-description">
                                                                        {item?.meterPhotos?.start ? (
                                                                            <span
                                                                                style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                                                                onClick={() => {

                                                                                    setPreviewFile({
                                                                                        url: getImageUrl(
                                                                                            item?.meterPhotos?.start
                                                                                        )
                                                                                    });

                                                                                    setShowPreview(true);

                                                                                }}
                                                                            >
                                                                                View Image-{item?.meterPhotos?.start}
                                                                            </span>
                                                                        ) : (
                                                                            "No image available"
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {item?.meterPhotos?.end ? (
                                                                            <span
                                                                                style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                                                                                onClick={() => {

                                                                                    setPreviewFile({
                                                                                        url: getImageUrl(
                                                                                            item?.meterPhotos?.end
                                                                                        )
                                                                                    });

                                                                                    setShowPreview(true);

                                                                                }}
                                                                            >
                                                                                View Image-{item?.meterPhotos?.end}
                                                                            </span>
                                                                        ) : (
                                                                            "No image available"
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                                {expandedRow === index && (item?.desile?.length || 0) > 0 && (
                                                                    <tr>
                                                                        <td colSpan="17" style={{ textAlign: "center" }}>
                                                                            <div style={{ display: "inline-block" }}>
                                                                                <table className="table table-bordered">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th>S.No</th>
                                                                                            <th>Diesel Qty</th>
                                                                                            <th>Reading</th>
                                                                                            <th>Diesel Fill-up Date</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {item.desile.map((diesel, dIndex) => (
                                                                                            <tr key={diesel._id}>
                                                                                                <td>{dIndex + 1}</td>
                                                                                                <td>{diesel.desileQty}</td>
                                                                                                <td>{diesel.reading}</td>
                                                                                                <td>{new Date(diesel.diseleFilupDate).toLocaleString()}</td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </>
                                                        );
                                                    })}
                                                    <tr className="bg-primary font-weight-bold">
                                                        <td colSpan="9" className="text-right fw-bolder fs-4">Total</td>

                                                        <td className="text-right fw-bolder fs-4">
                                                            {reportData.reduce((total, item) => total + handleHMR(item?.startKM, item?.endKM), 0).toFixed(2)}
                                                        </td>
                                                        <td className="text-right fw-bolder fs-5">
                                                            {reportData.reduce((total, item) => total + (item?.desile?.reduce((sum, diesel) => sum + diesel.desileQty, 0) || 0), 0).toFixed(2)}
                                                        </td>

                                                        <td colSpan="5"></td>
                                                    </tr>
                                                </>
                                            ) : (
                                                <tr>
                                                    <td colSpan="17" className="text-center">No data available.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>




                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>
            </div>
        </>
    );
};

export default MachineLogSheet;
